// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BELku","comment":"styles_comment__1bNJq"};